import { z } from 'zod'

export const addressSchema = z.object({
  zip_code: z.string().min(1, 'Obrigatório'),
  street: z.string().min(1, 'Obrigatório'),
  number: z.string().min(1, 'Obrigatório'),
  complement: z.string().max(30, 'Máximo de 30 caracteres').optional(),
  district: z.string().min(1, 'Obrigatório').max(45, 'Máximo de 45 caracteres'),
  ibge_code: z
    .string()
    .nullable()
    .refine((value) => value !== null && value !== '', {
      message: 'Obrigatório',
    }),
  state_code: z
    .string()
    .nullable()
    .refine((value) => value !== null && value !== '', {
      message: 'Obrigatório',
    }),
})
